import React, { ComponentType } from 'react';
import { isEmpty, map } from 'lodash';
import { TableBody as MuiTableBody, TableCell, TableRow } from '@mui/material';
import { TableCardRowProps } from '../Table/types';

const styles = {
  emptyCell: {
    textAlign: 'center',
    borderBottom: 0,
    padding: '40px',
  },
};

export type TableBodyIdByProp<T> = string | ((item: T) => string);

type TableBodyProps<T> = {
  idBy?: TableBodyIdByProp<T>;
  children: T[];
  rowComponent: ComponentType<TableCardRowProps<T>>;
  emptyComponent?: string;
};

const getChildKey = <T,>(item: T, index: number, idBy?: TableBodyIdByProp<T>) => {
  if (idBy === undefined) {
    return index;
  }

  if (typeof idBy === 'string') {
    return map([item], idBy)[0];
  }

  return idBy(item);
};

const TableBody = <T,>({ idBy, children, rowComponent: RowComponent, emptyComponent }: TableBodyProps<T>) => {
  return (
    <MuiTableBody>
      {isEmpty(children) && emptyComponent && (
        <TableRow>
          <TableCell sx={styles.emptyCell} colSpan={20}>
            {emptyComponent}
          </TableCell>
        </TableRow>
      )}
      {map(children, (item, index) => (
        <RowComponent
          key={getChildKey(item, index, idBy)}
          item={item}
          cellComponent={TableCell}
          rowComponent={TableRow}
        />
      ))}
    </MuiTableBody>
  );
};

export { TableBody };
